<template>
  <div class="room-list" :style="cssProps">
    <div v-for="(benefit, idx) in benefitsArr" :key="idx" class="list-item">
      <img src="@/assets/icons/ico-check-circle.svg" alt="" />
      <span>{{ benefit }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoomList',
  props: {
    benefitsArr: {
      type: Array,
      required: true,
    },
    columns: {
      type: String,
      required: true,
    },
  },
  computed: {
    cssProps() {
      return {
        '--columnNum': this.columns,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.room-list {
  column-count: var(--columnNum);
  column-gap: 64px;

  font-size: 16px;
  color: hsl(var(--clr-primary-100));

  .list-item {
    margin-bottom: 1.2em;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:last-child {
      margin-bottom: 0;
    }
    img {
      margin-right: 4px;
    }
  }
}

@media (max-width: 900px) {
  .room-list {
    font-size: 12px;
    column-gap: 12px;

    .list-item {
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
